export const handleChangeZip = event => {
  const { target: { value } = {} } = event || {}
  if (/\D/.test(value) || value.length > 5) {
    event.preventDefault()
  }
}

export const zipValidation = value => /(^\d{5}$)/.test(value) ? undefined : 'Please enter a valid ZIP Code'

export const validateZipWithPrefill = v => v && zipValidation(v)
